import React from "react";
import { FormattedMessage } from "react-intl";

export const ProtectionCategoriesStatus = ({
  filteredCategoriesCount,
  allCategoriesCount,
}) => {
  return (
    <div className="sr-only" role="status">
      <FormattedMessage
        id="aria_protection_categories_count"
        values={{
          allCategories: allCategoriesCount,
          shownCategories: filteredCategoriesCount,
        }}
      />
    </div>
  );
};
